import { render, staticRenderFns } from "./BoxOfficeSettings.vue?vue&type=template&id=313026d4&"
import script from "./BoxOfficeSettings.vue?vue&type=script&lang=js&"
export * from "./BoxOfficeSettings.vue?vue&type=script&lang=js&"
import style0 from "./BoxOfficeSettings.vue?vue&type=style&index=0&id=313026d4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports